import { useQueryClient } from "@tanstack/react-query";

import { usePostControlProgramsTags } from "api/generated/control-program/control-program";

import { CONTROL_PROGRAM_TAGS_QUERY_KEY } from "./useControlProgramTagsQuery";

export const useCreateControlProgramTagMutation = () => {
    const queryClient = useQueryClient();

    return usePostControlProgramsTags({
        mutation: {
            onSuccess: (response) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(
                        `Failed to create a new tag. HTTP status: ${response.status}`
                    );
                }
                return queryClient.invalidateQueries({
                    queryKey: [CONTROL_PROGRAM_TAGS_QUERY_KEY],
                });
            },
        },
    });
};
